import { render, staticRenderFns } from "./userEmployeesEdit.vue?vue&type=template&id=506bb592&scoped=true"
import script from "./userEmployeesEdit.vue?vue&type=script&lang=js"
export * from "./userEmployeesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506bb592",
  null
  
)

export default component.exports